<template>
  <!--    <Navbar :rightBtn="true"  :title="'立项查询结果'"></Navbar>-->
  <div class="content-bg">
    <!--         <img class="img" src="@/assets/images/bg/bg_6@2x.png" />-->
    <div class="title">全国政策申报立项数据库</div>
    <div class="sub-title">查询百万条企业立项信息</div>
    <div class="header">
      <div class="match-container-search" @click.stop="() => { }">
        <input type="text" placeholder="请输入申报单位关键词" v-model="company" @focus="handleInput"
               @keyup.enter="onSearch"/>
        <div class="btn" @click="onSearch">
          <img src="@/assets/images/vector@2x.png" alt="">
        </div>
      </div>
    </div>
  </div>
  <div class="empty" v-show="emptyShow">
    <div class="empty-txt">{{ emptyTxt }}</div>
    <div class="empty-img-box">
      <img src="@/assets/images/empty_1@2x.png"/>
    </div>
  </div>
  <div class="tags-title" v-if="listTotal > 0">为您找到 <span style="color:red">{{ listTotal }}</span> 条相关结果</div>
  <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" v-if="!emptyShow" @load="getData"
            immediate-check="false">
    <div class="policy-file-item" v-for="record in list" :key="record">
      <div class="content">
        <div><span class="label">政策名称：</span>{{ record._PolicyName.replace(/[\n\r]/g, '') }}</div>
        <div><span class="label">政策类型：</span>{{ record._PolicyProperty.replace(/[\n\r]/g, '') || '-' }}</div>
        <div><span class="label">申报单位：</span><span
            v-html="highlightKeyword(record._CompanyName.replace(/[\n\r]/g, ''))"></span></div>
        <div><span class="label">项目类型：</span>{{ record._ProjectType.replace(/[\n\r]/g, '') || '-' }}</div>
        <div><span class="label">所属口径：</span>{{ record._Source.replace(/[\n\r]/g, '') || '-' }}</div>
        <div><span class="label">立项时间：</span>{{ record._ApprovalDate || '-' }}</div>
        <div v-if="record._PolicyProperty == '资金'"><span class="label">立项金额：</span><span v-if="record._ApprovalAmount
         >0">{{
            record._ApprovalAmount.toString().replace(/(?:\.0*|(\.\d+?)0+)$/, '$1')
          }}万元</span><span v-else>-</span></div>
      </div>
    </div>
  </van-list>
  <!-- 回到顶部按钮 -->
  <div @click="backTop" class="backTop" v-show="backTopShow">
    <img src="../../assets/images/backTop.svg" alt="回顶部">
  </div>
</template>
<script>
import Navbar from '@/components/Navbar'
import {lxcxLists} from '@/api/home'

export default {

  data() {

    return {
      list: [],
      loading: false,
      finished: false,
      listTotal: 0,
      company: '',
      emptyShow: true,
      emptyTxt: '信息再多，一查便知。',
      page: {
        count: 0,
        size: 50,
        total: 0
      },
      searchParams: {
        type: Object,
        default: () => ({
          keyword: "",
        })
      },
      backTopShow: false,
    }
  },
  components: {Navbar,},
  computed: {},

  mounted() {
    this.onSearch()
    window.addEventListener('scroll', this.handleScroll)
  },
  watch: {},
  methods: {
    async onSearch() {
      const that = this;
      if (!this.company) {
        return false
      }
      this.searchParams.keyword = this.company
      that.list = []
      that.page.count = 0
      await that.getData()
    },
    async getData() {
      var that = this
      this.page.count += 1
      this.loading = true
      this.$toast.loading({
        forbidClick: true
      })
      try {
        let params = {
          company: this.company,
          page: this.page.count,
          pageSize: this.page.size,
        }
        let res = await lxcxLists(params)
        if (res.result.result == 'fail') {
          this.$toast({message: res.result.msg})
          return false
        }
        that.$toast.clear()
        if (res.result.tablerecord) {
          this.list = this.list.concat(res.result.tablerecord) || []
          this.page.total = Number(res.result.recordcount) || 0
          this.listTotal = Number(res.result.recordcount) || 0
          this.finished = this.list.length >= this.listTotal && this.listTotal != 0 ? true : false
          this.emptyShow = !this.listTotal ? true : false
        } else {
          this.list = []
          this.listTotal = 0
          this.page.total = 0
          this.emptyShow = true
          this.emptyTxt = '暂无数据'
        }
      } catch {

      } finally {
        this.loading = false
      }
    },
    handleScroll() {
      if (window.scrollY > 400) {
        this.backTopShow = true
      } else {
        this.backTopShow = false
      }
    },
    backTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动动画
      });
      this.backTopShow = false
    },
    // 高亮显示搜索关键词
    highlightKeyword(text) {
      if (!this.searchParams || !this.searchParams.keyword || !text) return text;

      const keyword = this.searchParams.keyword.trim();
      if (!keyword) return text;

      // 转义正则表达式特殊字符
      const escapeRegExp = (string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      };

      const regex = new RegExp(`(${escapeRegExp(keyword)})`, 'gi');
      return text.replace(regex, '<span class="highlight">$1</span>');
    },
  }
}
</script>

<style lang="scss">
/* 高亮文本样式 */
.highlight {
  color: #E60012;
  font-weight: bold;
}

.tags-title {
  margin: 5px 10px;
  font-weight: bold;
  font-size: 15px;
  color: #444;
  padding: 5px 20px;
  position: relative;
  background: #f9f9f9;
  border-bottom: 1px solid rgba(230, 0, 18, 0.05);
}
</style>

<style lang="scss" scoped>
@import "./index.scss";
</style>
